<template>
    <div>
        <div class="search-wrapper">
            <b-container class="pt-3 pb-2">
                <Search :search="search" @update-search="updateSearch" /> 
            </b-container>
        </div>
        <div class="site-content">
            <b-container>
                <header class="page-header">
                    <h1 class="display-1">Secure booking — only takes 2 minutes!</h1>
                </header>
                <CovidAlert/>
                <div class="errors" v-if="errors.length">
                    <div v-for="error in errors" :key="error">
                        <b-alert class="mt-4 mb-4" show variant="danger">
                            {{ error.code }} {{ error.title }}
                        </b-alert >
                    </div>
                    <div class="mb-5">
                        <FeaturedHotels :search="search" />
                    </div>
                </div>
                <div v-else>
                    <b-row>
                        <b-col md="8">
                            <div class="booking-wrap">
                                <div v-if="booking">
                                    <pre>
                                        {{ hotel }}
                                    </pre>
                                    <pre>
                                        {{ booking }}
                                    </pre>
                                    <div class="item-wrap">
                                        <strong>Free cancellation before Fri, Aug 20, 4:00pm (W. Europe Standard Time)</strong><br>
                                        <p>You can change or cancel this stay for a full refund if plans change. Because flexibility matters.</p>
                                    </div>
                                    <div class="item-wrap offers" v-for="offer in booking.offers" :key="offer">
                                        <div class="guests">
                                            <div class="guest" v-for="index in parseInt((offer.roomQuantity || 1) )" :key="index">
                                                <h3>Kamer {{ index }}</h3>
                                                <label>Guest</label>
                                                <b-input/>
                                                <label>Mobile</label>
                                                <b-input/>
                                                <label>Requests</label>
                                                <p>Special/Accessibility requests (optional)</p>
                                                <p>Special/accessibility requests (e.g. roll-away beds, late check-in, and accessible rooms) are not guaranteed. If you don't hear back from the property, you may want to contact them directly to confirm. The property may charge a fee for certain special requests.</p>
                                                <b-textarea/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="item-wrap payment">
                                        <Creditcard/>
                                    </div>
                                    <div class="item-wrap manage">
                                        <h3>Manage your booking</h3>
                                        <h4>Confirmation email</h4>
                                        <p>Please enter the email address where you would like to receive your confirmation.</p>
                                        <h4>Create an account</h4>
                                        <p>Enter a password to create an account using the email address above.</p>
                                        <p>By creating an account, I agree to the Terms of Use, Privacy Policy, and Stay.com Rewards Terms and Conditions.</p>
                                    </div>
                                    <div class="item-wrap payment">
                                        <h3>Important information about your booking</h3>
                                        <p style="font-size:11px;">By clicking on the button below, I acknowledge that I have reviewed the Privacy Statement. and Government Travel Advice and Terms of Use.</p>
                                        <b-button class="mb-3" variant="primary">
                                            Complete Booking
                                            <i class="fa fa-arrow-right"></i>
                                        </b-button>
                                        <p style="font-size:11px;"><i class="fa fa-lock"></i> We use secure transmission and encrypted storage to protect your personal information.</p>
                                        <p style="font-size:11px;">This payment will be processed in the EU. This does not apply when the travel provider (airline/hotel/rail, etc.) processes your payment.</p>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="item-wrap">
                                        <content-placeholders :rounded="true" :centered="true">
                                            <content-placeholders-heading/>
                                            <content-placeholders-text :lines="4"/>
                                        </content-placeholders>
                                    </div>
                                    <div class="item-wrap">
                                        <content-placeholders :rounded="true" :centered="true">
                                            <content-placeholders-heading/>
                                            <content-placeholders-text :lines="4"/>
                                        </content-placeholders>
                                    </div>
                                    <div class="item-wrap">
                                        <content-placeholders :rounded="true" :centered="true">
                                            <content-placeholders-heading/>
                                            <content-placeholders-text :lines="4"/>
                                        </content-placeholders>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col md="4">
                            <div v-if="hotel">
                                <div class="item-wrap">
                                    
                                    <div class="item offer" v-for="offer in booking.offers" :key="offer">
                                        {{ offer.roomQuantity }} {{ offer.room.typeEstimated.type }}
                                    </div>
                                    <p> Room: Deluxe Room, 1 King Bed</p>
                                    <p>Check-in: Fri, Aug 27</p>
                                    <p>Check-out: Sat, Aug 28 </p>
                                    <p>Nights: 1</p>
                                </div>
                                <div class="item-wrap">
                                    <h3>Price details</h3>
                                    <p>1 room x 1 night</p>
                                    <p>Taxes and fees</p>
                                    <p>Local tax $8.88 Payable at property</p>
                                    <hr>
                                    <h4>Total</h4>
                                    <p>Pay now</p>
                                    <p>Pay at property</p>
                                    <p>Rates are quoted in Euro. Taxes and/or property-imposed fees of $20.40 will be collected by the property in Euros (€17.38). Taxes and/or fees due at the property are based on current exchange rates, which may vary at the time of travel.</p>
                                </div>
                            </div>
                            <div v-else>
                                <div class="item-wrap">
                                    <content-placeholders :rounded="true" :centered="true">
                                        <content-placeholders-img/>
                                        <content-placeholders-heading/>
                                        <content-placeholders-text :lines="4"/>
                                    </content-placeholders>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import Search from '@/components/ui/Search'
    import CovidAlert from '@/components/ui/CovidAlert'
    import Creditcard from '@/components/ui/Creditcard'

    export default {
        components: {
            Search,
            CovidAlert,
            Creditcard,
        },
       data () {
            return {
                search: {
                    place: {
                        name: '',
                        lat: '',
                        lng: '',
                    },
                    date: {
                        checkin: '',
                        checkout: '',
                    },
                    occupation: {
                        adults: 0,
                        rooms: 0,
                        children: 0,
                        ages: [],
                    },
                    sort: '',
                    currency: '',
                    page: 1,
                },
                done: true,
                booking: [],
                hotel: [],
                errors: [],
                creditcard: {
                    cardName: "",
                    cardNumber: "",
                    cardMonth: "",
                    cardYear: "",
                    cardCvv: "",
                },
            }
        },
        mounted () {
            this.search.place.name = (this.$route.query.search ? this.$route.query.search : null);
            this.search.place.lat = (this.$route.query.lat ? this.$route.query.lat : null);
            this.search.place.lng = (this.$route.query.lng ? this.$route.query.lng : null);
            this.search.date.checkin = (this.$route.query.checkin ? this.$route.query.checkin : null);
            this.search.date.checkout = (this.$route.query.checkout ? this.$route.query.checkout : null);
            this.search.occupation.adults = (this.$route.query.adults ? parseInt(this.$route.query.adults) : 0);
            this.search.occupation.children = (this.$route.query.children ? parseInt(this.$route.query.children) : 0);
            this.search.occupation.rooms = (this.$route.query.rooms ? parseInt(this.$route.query.rooms) : 0);
            this.search.occupation.ages = (this.$route.query.ages ? JSON.parse(this.$route.query.ages) : []);
            this.search.currency = (this.$route.query.currency ? this.$route.query.currency : 'EUR');
            this.search.sort = (this.$route.query.sort ? this.$route.query.sort : null);
            this.search.page = (this.$route.query.page ? this.$route.query.page : 1);
            this.loadResults();
        },
        methods: {
            updateSearch(search) {
                this.search = search;
                this.loadResults();
            },
            loadResults() {

                this.booking = [];
                this.hotel = [];
                
                axios
                    .get('https://api.stay.com.de/?action=hotel-book' + 
                        '&id=' + this.fromHex(this.$route.params.offer) +
                        '&mode=' + process.env.VUE_APP_MODE
                    )
                    .then(response => {
                        if (response.data.data) {
                            this.booking = response.data.data
                        }

                        if (response.data.errors) {
                            self.errors = response.data.errors;
                        }
                    })
                ;

                axios
                    .get('https://api.stay.com.de/?action=hotel-detail' +
                        '&currency=' + self.search.currency +
                        '&id=' + this.fromHex(this.$route.params.id) +
                        '&lat=' + this.search.place.lat + 
                        '&lng=' + this.search.place.lng +
                        '&checkin=' + this.search.date.checkin +
                        '&checkout=' + this.search.date.checkout +
                        '&adults=' + this.search.occupation.adults +
                        '&children=' + this.search.occupation.children +
                        '&ages=' + JSON.stringify(this.search.occupation.ages) +
                        '&rooms=' + this.search.occupation.rooms +
                        '&mode=' + process.env.VUE_APP_MODE
                    )
                    .then(response => {
                        if (response.data.data) {
                            this.hotel = response.data.data
                        }

                        if (response.data.errors) {
                            self.errors = response.data.errors;
                        }
                    })
                ;
            },
            fromHex(h) {
                var s = ''
                for (var i = 0; i < h.length; i+=2) {
                    s += String.fromCharCode(parseInt(h.substr(i, 2), 16))
                }
                return decodeURIComponent(escape(s))
            }
        }
    }
</script>

<style>
    @media screen and (min-width:991px) {
        .search-wrapper .form-group{
            margin:0;
        }
    }
</style>
<style scoped>
    .search-wrapper{
        background-color:#F3F3F3;
    }

    .item-wrap{
        background-color:#fff;
        padding:20px;
        margin-bottom:25px;
    }
   


    .gallery {
        width: 100% !important;
        height: 150px !important;
    }

    .gallery {
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }
</style>